// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"f5bf9e62","810":"fff8eb65"}[chunkId] + ".chunk.js";
};